export const MESSAGES = {
  // Generic spacing
  noLeadingSpaces: "No leading spaces are allowed.",
  noTrailingSpaces: "No trailing spaces are allowed.",
  onlyOneSpaceBetweenDobAndLastName:
    "Please use only one space between the date of birth and the last name.",

  // DOB + Last Name
  enterCompleteDob: "Please enter date of birth as mm/dd/yyyy",
  dobFormat: "Please enter date of birth as mm/dd/yyyy",
  dobInvalid: "Please enter a valid date of birth as mm/dd/yyyy",
  lastNameMin3:
    "Please enter the first three letters of the patient’s last name",
  first3LettersAfterDob:
    "Please enter the first three letters of last name.",
  onlyNumbersDobLettersLast:
    "Only numbers for DOB and letters for the last name are allowed.",
  lastNameLettersOnly: "Last name should only contain alphabets.",
  futureDate: "Date of birth cannot be in the future. Please enter a valid date.",

  // Medicaid ID
  medicaidNoSpaces: "Medicaid ID cannot contain spaces.",
  medicaidEnterValid: "Please enter a valid Medicaid ID.",
  medicaidAlphanumeric: "Please enter a valid Medicaid ID.",

  // EditLayout toast messages
  preferredLayoutSaved: "My Layout saved successfully",
  defaultLayoutRestored: "Default layout restored successfully",
  preferredLayoutRestored: "My Layout restored successfully",
} as const;

export type MessageKey = keyof typeof MESSAGES;

